export class BidderAdvertisersRoutes {
	private baseRoute = 'bidder/advertisers';

	advertisers() {
		return `/${this.baseRoute}/`;
	}

	createAdvertiser() {
		return `/${this.baseRoute}/create`;
	}

	editAdvertiser(id: string) {
		return `/${this.baseRoute}/${id}/edit`;
	}

	duplicateAdvertiser(id: string) {
		return `/${this.baseRoute}/${id}/duplicate`;
	}
}
